// src/services/api/dispatch.js
import { apiClient } from './base';

/**
 * Dispatch a single order by scanning airwaybill or order number
 * @param {Object} dispatchData - Dispatch data
 * @param {string} dispatchData.identifier - Airwaybill number or order number
 * @param {string} dispatchData.dispatchedDate - Dispatch date (optional, defaults to today)
 * @returns {Promise<Object>} Dispatch result with order details
 */
export const dispatchSingleOrder = async (dispatchData) => {
  try {
    const response = await apiClient.post('/dispatch/single', dispatchData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Dispatch all orders in a packing batch
 * @param {number} batchId - The packing batch ID
 * @param {Object} dispatchData - Dispatch data
 * @param {Array<number>} dispatchData.excludeOrderIds - Order IDs to exclude (optional)
 * @param {string} dispatchData.dispatchedDate - Dispatch date (optional, defaults to today)
 * @returns {Promise<Object>} Batch dispatch result
 */
export const dispatchPackingBatch = async (batchId, dispatchData) => {
  try {
    const response = await apiClient.post(`/dispatch/batch/${batchId}`, dispatchData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Get dispatch history for a specific order
 * @param {number} orderId - The order ID
 * @returns {Promise<Object>} Order dispatch history
 */
export const getOrderDispatchHistory = async (orderId) => {
  try {
    const response = await apiClient.get(`/dispatch/orders/${orderId}/history`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Get dispatch statistics
 * @param {Object} params - Query parameters
 * @param {string} params.dateFrom - Start date (optional)
 * @param {string} params.dateTo - End date (optional)
 * @param {number} params.warehouseId - Warehouse ID filter (optional)
 * @param {number} params.shopId - Shop ID filter (optional)
 * @returns {Promise<Object>} Dispatch statistics
 */
export const getDispatchStatistics = async (params = {}) => {
  try {
    const response = await apiClient.get('/dispatch/statistics', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};